import { useMemo } from 'react';
export const useIsSuperAdmin = user => useMemo(() => user.scopes.includes('super-admin'), [user]);